import { $, $$ } from '@zimpa/dom';
import axios, { AxiosResponse } from 'axios';

const SHOW_SELECTOR = '.js-comment-show-form';
const FORM_SELECTOR = '.js-comment-form';
const FIELD_SELECTOR = '.js-comment-field';
const PARENT_INPUT_SELECTOR = '.js-comment-parent';
const REPLY_SELECTOR = '.js-comment-reply';
const SEND_SELECTOR = '.js-comment-send';
const FOCUS_SELECTOR = '.js-comment-autofocus';
const BUTTON_SELECTOR = '.js-comment-button';

const VISIBLE_CLASS = 'visible';
const HIDE_CLASS = 'hide';
const ERROR_CLASS = 'error';

type Data = {
    [field: string]: string;
};

type Response = {
    success?: boolean;
};

function visible(form) {
    form.classList.add(VISIBLE_CLASS);
    $<HTMLTextAreaElement | HTMLInputElement>(FOCUS_SELECTOR)!.focus();
}

function reply(form): void {
    $$<HTMLElement>(REPLY_SELECTOR).forEach((e: HTMLElement): void => {
        const commentId = <string>e.getAttribute('data-comment');

        e.addEventListener('click', (): void => {
            const container = $<HTMLElement>(`#comment-${commentId}`);
            const input = $<HTMLElement>(PARENT_INPUT_SELECTOR, form);

            if (container !== undefined && input !== undefined) {
                if (container.nextElementSibling === null) {
                    (<HTMLElement>container.parentNode).appendChild(form);
                } else {
                    (<HTMLElement>container.parentNode).insertBefore(
                        form,
                        container.nextElementSibling,
                    );
                }

                input.setAttribute('value', commentId);
            }

            visible(form);
        });
    });
}

function submit(form: HTMLElement) {
    const result = $<HTMLElement>(SEND_SELECTOR);
    const data = $$<HTMLInputElement | HTMLTextAreaElement>(
        FIELD_SELECTOR,
    ).reduce(
        (acc: Data, field: HTMLInputElement | HTMLTextAreaElement): Data => {
            acc[field.name] = <string>field.value;

            return acc;
        },
        {},
    );

    axios
        .post('/wp-admin/admin-ajax.php?action=zmp_add_comment', data)
        .then((response: AxiosResponse<Response>): void => {
            if (result === undefined) {
                return;
            }

            (<HTMLElement>form.parentNode).insertBefore(result, form);
            form.classList.remove(VISIBLE_CLASS);
            form.classList.add(HIDE_CLASS);
            result.classList.add(VISIBLE_CLASS);

            if (response.data.success !== true) {
                result.classList.add(ERROR_CLASS);
                result.innerText = result.getAttribute('data-error') ?? '';
            } else {
                result.innerText = result.getAttribute('data-success') ?? '';
            }
        });
}

export function comment(): void {
    const button = $<HTMLButtonElement>(BUTTON_SELECTOR);
    const trigger = $<HTMLElement>(SHOW_SELECTOR);
    const form = $<HTMLElement>(FORM_SELECTOR);

    if (form === undefined || trigger === undefined) {
        return;
    }

    form.addEventListener('submit', (event: Event) => {
        event.preventDefault();

        if(typeof button !== 'undefined') button.disabled = true;

        submit(form);
    });

    trigger.addEventListener('click', (): void => {
        visible(form);
    });

    reply(form);
}
